import { render } from "./addModuleIndustry.vue?vue&type=template&id=586599c5&scoped=true"
import script from "./addModuleIndustry.vue?vue&type=script&lang=js"
export * from "./addModuleIndustry.vue?vue&type=script&lang=js"

import "./addModuleIndustry.vue?vue&type=style&index=0&id=586599c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586599c5"]])

export default __exports__